import { checkCSVForErrors, removeSkuDuplicates, constructJSON } from "../utils/csvUtils";
import { FetchedOrderUploadProduct, IFetchProductsResponse, IProgressBarLevel } from "../types";
import fetchItemDetails from "../fetchs/fetchItemDetails";

const fetchProducts = async (
  csvProducts: string[][],
  setProgressBarLevel?: (progressBarLevel: IProgressBarLevel) => void,
): Promise<IFetchProductsResponse> => {
  // Check if there are any products to fetch
  if (csvProducts.length === 0) {
    return {
      status: 400,
      message: "No products to fetch",
    };
  }

  // Check if there are any invalid products
  const invalidProducts = checkCSVForErrors(csvProducts);
  if (invalidProducts.length > 0) {
    return {
      status: 400,
      message: "Invalid products",
    };
  }

  // Fetching products
  const constructedData = constructJSON(csvProducts);
  const cleanedConstructedData = removeSkuDuplicates(constructedData);

  const fetchedProducts: FetchedOrderUploadProduct[] = [];

  // Initialize progress bar
  setProgressBarLevel?.({
    level: 0,
    totalItems: cleanedConstructedData.length,
  });

  // Process items sequentially to update progress bar for each item
  for (let index = 0; index < cleanedConstructedData.length; index++) {
    const data = cleanedConstructedData[index];

    try {
      const fetchedProduct = await fetchItemDetails(data, index);
      if (fetchedProduct) {
        fetchedProducts.push(fetchedProduct);
      } else {
        // Use original CSV data when fetch fails - get the item number using the index
        const originalRow = cleanedConstructedData[index];
        fetchedProducts.push({
          index: index.toString(),
          itemNo: originalRow.sku,
          csvLineArray: csvProducts[index],
        });
      }
    } catch (error) {
      // Handle any errors during fetch and use original CSV data
      const originalRow = cleanedConstructedData[index];
      fetchedProducts.push({
        index: index.toString(),
        itemNo: originalRow.sku,
        csvLineArray: csvProducts[index],
      });
    }

    // Update progress bar after processing each item
    setProgressBarLevel?.({
      level: index + 1,
      totalItems: cleanedConstructedData.length,
    });
  }

  return {
    status: 200,
    message: "Products fetched successfully",
    fetchedProducts,
  };
};

export default fetchProducts;
